import {
  ModalOpenContext,
  ModalOpenContextBuilder,
  FluentAssignMethod,
  extend,
  arrayUnion
} from 'angular2-modal';

const /** @type {?} */ DEFAULT_VALUES = {
    dialogClass: 'modal-dialog',
    showClose: false
};

const /** @type {?} */ DEFAULT_SETTERS = [
    'dialogClass',
    'size',
    'showClose'
];


export type BootstrapModalSize = 'sm' | 'lg';
export class BSModalContext extends ModalOpenContext {
/**
 * A Class for the modal dialog container.
 * Default: modal-dialog
 */
dialogClass: string;
/**
 * Size of the modal. 'lg' or 'sm' only.
 * 
 * If you want to use custom sizes leave this empty and set the dialogClass property.
 * e.g: dialogClass = 'modal-dialog my-custom-dialog`
 * NOTE: No validation.
 * Default: ''
 */
size: BootstrapModalSize;
/**
 * When true, show a close button on the top right corner.
 */
showClose: boolean;
/**
 * @return {?}
 */
normalize(): void {
        if (!this.dialogClass) {
            this.dialogClass = DEFAULT_VALUES.dialogClass;
        }

        super.normalize();
    }
}

function BSModalContext_tsickle_Closure_declarations() {
/**
 * A Class for the modal dialog container.
 * Default: modal-dialog
 * @type {?}
 */
BSModalContext.prototype.dialogClass;
/**
 * Size of the modal. 'lg' or 'sm' only.
 * 
 * If you want to use custom sizes leave this empty and set the dialogClass property.
 * e.g: dialogClass = 'modal-dialog my-custom-dialog`
 * NOTE: No validation.
 * Default: ''
 * @type {?}
 */
BSModalContext.prototype.size;
/**
 * When true, show a close button on the top right corner.
 * @type {?}
 */
BSModalContext.prototype.showClose;
}

export class BSModalContextBuilder<T extends BSModalContext> extends ModalOpenContextBuilder<T> {
/**
 * A Class for the modal dialog container.
 * Default: modal-dialog
 */
dialogClass: FluentAssignMethod<string, this>;
/**
 * Size of the modal. 'lg' or 'sm' only.
 * 
 * If you want to use custom sizes leave this empty and set the dialogClass property.
 * e.g: dialogClass = 'modal-dialog my-custom-dialog`
 * NOTE: No validation.
 * Default: ''
 */
size: FluentAssignMethod<BootstrapModalSize, this>;
/**
 * When true, show a close button on the top right corner.
 */
showClose: FluentAssignMethod<boolean, this>;
/**
 * @param {?=} defaultValues
 * @param {?=} initialSetters
 * @param {?=} baseType
 */
constructor(
        defaultValues: T = undefined,
        initialSetters: string[] = undefined,
        baseType: any = undefined
    ) {
        super(
            extend<any>(DEFAULT_VALUES, defaultValues || {}),
            arrayUnion<string>(DEFAULT_SETTERS, initialSetters || []),
            baseType || <any>BSModalContext // https://github.com/Microsoft/TypeScript/issues/7234
        );
    }
}

function BSModalContextBuilder_tsickle_Closure_declarations() {
/**
 * A Class for the modal dialog container.
 * Default: modal-dialog
 * @type {?}
 */
BSModalContextBuilder.prototype.dialogClass;
/**
 * Size of the modal. 'lg' or 'sm' only.
 * 
 * If you want to use custom sizes leave this empty and set the dialogClass property.
 * e.g: dialogClass = 'modal-dialog my-custom-dialog`
 * NOTE: No validation.
 * Default: ''
 * @type {?}
 */
BSModalContextBuilder.prototype.size;
/**
 * When true, show a close button on the top right corner.
 * @type {?}
 */
BSModalContextBuilder.prototype.showClose;
}


